<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">钢铁</span> > 产量</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>产量</p>
        <div class="btn fr" @click="search">搜索</div>
        <input v-if="this.queryParams['dictDataType'] !== '6' && this.queryParams['dictDataType'] !== '7'" class="fr" type="text" v-model="queryParams.likeTitleName" placeholder="请输入关键词">
        <input v-else class="fr" type="text" v-model="query.likeTitleName" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs('issue_steel_varieties_yield', 2)"
             :class="{'hover':queryParams['dictDataType'] === 'issue_steel_varieties_yield'}">五大品种合计产量
        </div>
        <div @click="changeTabs('issue_steel_group_province', 5)"
             :class="{'hover':queryParams['dictDataType'] === 'issue_steel_group_province'}">粗钢/生铁/钢材产量
        </div>
        <div @click="changeTabs('7')" :class="{'hover':queryParams['dictDataType'] === '7'}">中钢协产量</div>
        <div @click="changeTabs('6')" :class="{'hover':queryParams['dictDataType'] === '6'}">国际产量</div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p v-if="queryParams['dictDataType'] === 'issue_steel_varieties_yield' || queryParams['dictDataType'] === 'issue_steel_group_province'"
             @click="goDetail(item.completeOriginalDate, queryParams['dictDataType'])">{{
              item.date + (queryParams['dictDataType'] === 'issue_steel_varieties_yield' ? '五大品种合计产量' : '粗钢/生铁/钢材产量分省')
            }}</p>
          <p v-else @click="goDetail(item.id, queryParams['dictDataType'])">{{ item.titleName }}</p>
          <span
              v-if="queryParams['dictDataType'] === 'issue_steel_varieties_yield' || queryParams['dictDataType'] === 'issue_steel_group_province'"
              class="fr">{{ item.completeOriginalDate }}</span>
          <span v-else class="fr">{{ item.showYearTime }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="queryParams['pageSize']"
          :current-page="queryParams['pageNum']"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  yieldPage,
  yieldLastTwoPage
} from '@/api/steel'

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        dictDataType: 'issue_steel_varieties_yield',
        likeTitleName:'',
        dataType: 2,
      },
      query: {
        pageNum: 1,
        pageSize: 15,
        sourceType: '7'
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.query['flag']) {
      this.queryParams['dictDataType'] = this.$route.query['flag']
      this.query['sourceType'] = this.$route.query['flag']
    }
    if (this.$route.query['num']) {
      this.queryParams['dataType'] = this.$route.query['num']
    }
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      this.list = []
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.queryParams['dictDataType'] === '6' || this.queryParams['dictDataType'] === '7') {
        yieldLastTwoPage(this.query).then(res => {
          this.list = res.rows;
          this.total = res.total;
          loading.close();
        })
      } else {
        yieldPage(this.queryParams).then(res => {
          this.list = res.rows;
          this.total = res.total;
          loading.close();
        })
      }
    },
    /**
     * 搜索
     */
    search() {
      this.query['pageNum'] = 1;
      this.queryParams['pageNum'] = 1;
      this.getList()
    },
    /**
     * 切换tabs
     */
    changeTabs(flag, num) {
      this.queryParams['dictDataType'] = flag;
      this.query['sourceType'] = flag;
      this.queryParams['dataType'] = num;
      this.queryParams['pageNum'] = 1;
      this.query['pageNum'] = 1;
      this.getList();
    },
    /**
     * 前往详情页
     */
    goDetail(id, flag) {
      if (this.queryParams['dictDataType'] === '6' || this.queryParams['dictDataType'] === '7') {
        this.$router.push({path: `/steel/industry`, query: {id, flag}})
      } else {
        this.$router.push({path: `/steel/yield`, query: {id, flag}})
      }
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/steel')
    },
    /**
     * 分页
     */
    goFirst() {
      this.queryParams['pageNum'] = 1;
      this.query['pageNum'] = 1;
      this.getList()
    },
    goLast() {
      this.queryParams['pageNum'] = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.queryParams['pageNum'] = page;
      this.query['pageNum'] = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
